import { setAddMany, setToString } from './set.utils.js';
function classNames(outputClassNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  args.forEach(arg => {
    if (arg && typeof arg === 'object') {
      if (Array.isArray(arg)) {
        setAddMany(outputClassNames, classNames(outputClassNames, ...arg));
      } else {
        Object.keys(arg).forEach(key => {
          if (arg[key]) {
            outputClassNames.add(key);
          }
        });
      }
    } else if (arg) {
      outputClassNames.add(arg);
    }
  });
  return outputClassNames;
}
function className() {
  const outputClassNames = new Set();
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return setToString(classNames(outputClassNames, ...args), ' ');
}
export { className, classNames };